import {Device} from './device';

export class BagElement {
  device: Device;
  quantity: number;

  constructor(dev?: Device, n?: number) {
   if (dev === undefined || n === undefined) {
     this.device   = null;
     this.quantity = null;
   } else {
     this.device   = dev;
     this.quantity = n;
   }
  }
}



// WEBPACK FOOTER //
// ./src/models/bagElement.ts